/**
 * @fileoverview This file serves as the single source of truth for all agent configurations.
 * It combines definitions from primitives and composites into a single master list.
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';

// Import agent definitions from the co-located structure
import { PRIMITIVE_AGENT_DEFINITIONS } from './primitives';
import { COMPOSITE_AGENT_DEFINITIONS } from './composites';
import { CONVERSATIONAL_AGENT_DEFINITIONS } from './conversational';

// The master list of all agent definitions in the application.
export const AGENT_DEFINITIONS: AppAgentDefinition[] = [
    ...PRIMITIVE_AGENT_DEFINITIONS,
    ...COMPOSITE_AGENT_DEFINITIONS,
    ...CONVERSATIONAL_AGENT_DEFINITIONS,
];

// Helper to get all agent IDs (used for filtering, etc.)
export const ALL_AGENT_IDS = AGENT_DEFINITIONS.map(def => def.id).sort();
